import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';

import {
  getUser,
  isActionAllowed,
} from '../../modules/contexts/Auth/RequireAuth';
import { Tramitacao } from '../../modules/types/Aquisicao';
import { LogData } from '../../modules/types/types';
import {
  handleCreateTramitacao,
  handleUpdateTramitacao,
  handleDeleteTramitacao,
  getAllTramitacoesPorEntidade,
} from '../../services/aquisicoes/TramitacaoService';
import { useModuloUsuario } from '../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../services/enum/usePapelUsuario';
import { isHttpError } from '../../services/httpClient';
import theme from '../../theme';
import { ENTITY } from '../../utils/entityNames';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateIntl,
  formatDateSimp,
  isDataMaiorOuIgual,
  sanitizarForm,
} from '../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../utils/swal';
import BarraInferiorBotoes from '../BarraInferiorBotoes';
import BoxConteudo from '../BoxConteudo';
import CustomCol from '../CustomCol';
import CustomRow from '../CustomRow';
import Input from '../InputNew';
import Log from '../Log/Log';
import Tabela from '../Tabela';
import WorkspaceBotoes from '../WorkspaceBotoes';
import WorkspaceFicha from '../WorkspaceFicha';
import {
  headersTramitacao as headers,
  valoresExibidosTramitacao as valoresExibidos,
} from './auxiliarTramitacao';
import CustomButton from '../CustomButton';
import CustomOffcanvas from '../CustomOffcanvas';

interface TramitacaoComponenteProps {
  tab: string;
  id_tab: string;
}

const tbEntity = ENTITY.ENTITY_Tramitacao_Sei;

function TramitacaoComponente({ tab, id_tab }: TramitacaoComponenteProps) {
  const user = getUser();
  const userID = user.sub;

  const [updating, setUpdating] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [logData, setLogData] = useState<LogData>();
  const [data, setData] = useState<Tramitacao[]>();

  const [form, setForm] = useState<Tramitacao>({
    id: 0,
    documentoSei: '',
    dataEntrada: '',
    seiUnidade: '',
    seiUsuario: '',
    seiDescricao: '',
    dataSaida: '',
    observacoes: '',
    tabId: parseInt(id_tab, 10),
    usuarioId: userID,
  });
  // tipoAquisicao: props.tipoAquisicao,

  const fetchData = async () => {
    try {
      const tramitacoes = await getAllTramitacoesPorEntidade(
        tab,
        Number(id_tab),
      );
      setData(tramitacoes);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id_tab]);

  // Funções handle
  const handleClearForm = () => {
    setForm({
      ...form,
      id: 0,
      documentoSei: '',
      dataEntrada: '',
      seiUnidade: '',
      seiUsuario: '',
      seiDescricao: '',
      dataSaida: '',
      observacoes: '',

      usuarioId: userID,
    });
    setLogData({
      ...logData,
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  // Tabela
  const tableData =
    data?.map((item: Tramitacao) => {
      return {
        id: item.id,
        dataEntrada: formatDateSimp(item.dataEntrada),
        dataSaida: formatDateSimp(item.dataSaida),
        seiUnidade: item.seiUnidade,
        seiUsuario: item.seiUsuario,
        seiDescricao: item.seiDescricao,
      };
    }) || [];

  const offcanvasData =
    data?.map((item: Tramitacao) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro ?? '') +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro?.nomeCompleto ?? ''),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao ?? '') +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao?.nomeCompleto ?? ''),

        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao ?? '') +
          ' - ' +
          formataNomeMeioSiglas(
            item.usuarioUltimaVisualizacao?.nomeCompleto ?? '',
          ),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        dataEntrada: item.dataEntrada ? formatDateSimp(item.dataEntrada) : '-',
        dataSaida: item.dataSaida ? formatDateSimp(item.dataSaida) : '-',
        seiUsuario: item.seiUsuario,
        seiUnidade: item.seiUnidade,
        seiDescricao: item.seiDescricao,
        separador: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //Funções Handle
  const handleShowModal = () => {
    setShowModal((prev) => !prev);
    handleClearForm();
  };

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    handleShowModal();
    setUpdating(true);
    const filteredItem = data?.find((item) => item.id == parseInt(id, 10));

    if (filteredItem) {
      setForm({
        id: filteredItem.id,
        documentoSei: filteredItem.seiUsuario,
        dataEntrada: formatDateIntl(filteredItem.dataEntrada),
        seiUnidade: filteredItem.seiUnidade,
        seiUsuario: filteredItem.seiUsuario,
        seiDescricao: filteredItem.seiDescricao,
        dataSaida: formatDateIntl(filteredItem.dataSaida),
        observacoes: filteredItem.observacoes ?? 'Não informado',

        // chave usuário
        usuarioId: userID,
        tabId: parseInt(id_tab, 10),
      });
      setLogData({
        id: filteredItem.id,
        usuarioRegistro: filteredItem.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao: filteredItem.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: filteredItem.dataRegistro || '',
        dataAtualizacao: filteredItem.dataUltimaAtualizacao || '',
        nEdicoes: filteredItem.nEdicoes || 0,
      });
    }
  };

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    setForm((prev) => {
      const updatedForm = { ...prev, [name]: value };

      if (
        name === 'dataSaida' &&
        !isDataMaiorOuIgual(updatedForm.dataEntrada, value)
      ) {
        swalAttention(
          'A Data de Saída deve ser igual ou posterior à Data de Entrada.',
        );
        return prev;
      }

      return updatedForm;
    });
  };

  const validateForm = (form: Tramitacao): boolean => {
    const erros: string[] = [];

    if (!form.dataEntrada) {
      erros.push('<b>Data Entrada</b> é obrigatória.');
    }

    if (!form.seiUnidade) {
      erros.push('<b>Unidade MS</b> é obrigatória.');
    }

    if (!form.seiUsuario) {
      erros.push('<b>Usuário SEI</b> é obrigatório.');
    }
    if (!form.seiDescricao) {
      erros.push('<b>Descrição</b> é obrigatória.');
    }

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  };

  const formatForm = (form: Tramitacao) => {
    const formAjustado = {
      ...form,
      usuarioId: form.usuarioId,
      tabId: parseInt(id_tab, 10),
    };

    return formAjustado;
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido.');
      const formAjustado = formatForm(form);
      const formToSend = sanitizarForm(formAjustado);

      await handleCreateTramitacao(formToSend, tab);

      swalSave();
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido.');
      const formAjustado = formatForm(form);
      const formToSend = sanitizarForm(formAjustado);

      const response = await handleUpdateTramitacao(formToSend);

      swalAtualizacao('Sucesso', response.data.message);
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await handleDeleteTramitacao(form.id);
      swalDeleteConfirm();
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  return (
    <BoxConteudo boxTitulo={'Tramitações SEI'} fechado>
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headers}
            dataTable={tableData}
            displayValues={valoresExibidos}
            onRowClick={handleRowClick}
            dataOffCanvas={offcanvasData}
            showPagination={false}
          />
        </CustomCol>
      </CustomRow>
      <Col className="d-flex justify-content-end">
        <CustomButton
          label="Nova tramitação"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={handleClickInserirNovo}
          disabled={id_tab == 'undefined' ? true : false}
        />
      </Col>

      <CustomOffcanvas
        title="Tramitações SEI"
        show={showModal}
        onClose={handleShowModal}
        width="60vw"
      >
        <WorkspaceFicha>
          <Log {...logData} entity={tbEntity} id={Number(form.id)} />
          <BoxConteudo boxTitulo={'Tramitação SEI'}>
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="190px">
                <Input
                  type="date"
                  name="dataEntrada"
                  value={form.dataEntrada}
                  id="dataEntrada"
                  label="Data Entrada"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="190px">
                <Input
                  type="date"
                  name="dataSaida"
                  value={form.dataSaida}
                  id="dataSaida"
                  label="Data Saída"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="seiUsuario"
                  value={form.seiUsuario}
                  id="seiUsuario"
                  label="Usuário SEI"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="seiUnidade"
                  name="seiUnidade"
                  value={form.seiUnidade}
                  onChange={handleChange}
                  label="Unidade MS"
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="seiDescricao"
                  type="textarea"
                  value={form.seiDescricao}
                  id="seiDescricao"
                  label="Descrição da Tramitação"
                  onChange={handleChange}
                  linhas={3}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <Col>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={form.observacoes}
                  label="Observações"
                  linhas={2}
                  onChange={handleChange}
                />
              </Col>
            </CustomRow>
          </BoxConteudo>
          <BarraInferiorBotoes>
            {updating ? (
              <WorkspaceBotoes
                delete
                onClickDelete={handleDelete}
                save
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes inserir onClickInserir={handleCreate} />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </CustomOffcanvas>
    </BoxConteudo>
  );
}

export default TramitacaoComponente;
